/**
 * legacy (batch) 経路の NSIPS 録音前画面.
 *
 * 本体 JSX は `@/apps/legacy/features/yakureki/screens/PreRecordingScreenContent` に集約済。
 * 本 wrapper は現時点では content をそのまま forward するのみ (legacy 固有拡張
 * があれば ここに差し込む).
 */
import { FC } from 'react'
import { PreRecordingScreenContent } from '@/apps/legacy/features/yakureki/screens/PreRecordingScreenContent'
import type { PreRecordingScreenProps } from '@/apps/legacy/features/yakureki/PreRecordingScreen'

export const NSIPSPreRecordingScreen: FC<PreRecordingScreenProps> = (props) => {
  return <PreRecordingScreenContent {...props} />
}
